import { GET_USER, GET_USER_SUCCESS, GET_USER_FAILURE,
        CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE } from '../Utils/Constants';

export const getUser = (payload) => {
    return {
        type: GET_USER,
        payload: payload
    }
}

export const getUserFailure = (payload) => {
    return {
        type: GET_USER_FAILURE,
        payload: payload
    }
}

export const getUserSuccess = (payload) => {
    return {
        type: GET_USER_SUCCESS,
        payload: payload
    }
}

export const changePassword = (payload) => {
    return {
        type: CHANGE_PASSWORD,
        payload: payload
    }
}

export const changePasswordSuccess = (payload) => {
    return {
        type: CHANGE_PASSWORD_SUCCESS,
        payload: payload
    }
}

export const changePasswordFailure = (payload) => {
    return {
        type: CHANGE_PASSWORD_FAILURE,
        payload: payload
    }
}
